import { render, staticRenderFns } from "./storeInfo.vue?vue&type=template&id=c93547fe&scoped=true"
import script from "./storeInfo.vue?vue&type=script&lang=js"
export * from "./storeInfo.vue?vue&type=script&lang=js"
import style0 from "./storeInfo.vue?vue&type=style&index=0&id=c93547fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93547fe",
  null
  
)

export default component.exports